import React from 'react';

const footerStyle = {
    padding: '1rem',
    marginTop: 'auto',
    backgroundColor: '#f8f9fa',
    textAlign: 'center',
    borderTop: '1px solid #e7e7e7',
    fontSize: '0.9rem',
    color: '#6c757d'
};

const logoStyle = {
    height: '24px',
    width: '24px',
    verticalAlign: 'middle',
    marginRight: '8px'
};

const linkStyle = {
    color: '#007bff',
    textDecoration: 'none'
};

const Footer = () => {
    return (
        <footer style={footerStyle}>
            <img src={`${process.env.PUBLIC_URL}/images/dev/logo-32.png`} alt="Techseed Logo" style={logoStyle} />
            <span style={{ verticalAlign: 'middle' }}>
                Developed by <a href="https://techseed.net" target="_blank" rel="noopener noreferrer" style={linkStyle}>Techseed</a>
            </span>
        </footer>
    );
};

export default Footer; 